export const getSafeString = (value: string | undefined): string => {
  return value ?? '-';
};
